import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const UTM_KEY = 'lokal_utm';
const UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ref'];

/** Capture UTM / referral params on first hit and persist for the whole session. */
export const captureUtm = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_FIELDS.forEach((k) => { const v = params.get(k); if (v) found[k] = v.slice(0, 120); });
  if (Object.keys(found).length) {
    found.landing = window.location.pathname;
    if (document.referrer) found.referrer = document.referrer.slice(0, 300);
    sessionStorage.setItem(UTM_KEY, JSON.stringify(found));
  } else if (!sessionStorage.getItem(UTM_KEY)) {
    const base = { landing: window.location.pathname };
    if (document.referrer) base.referrer = document.referrer.slice(0, 300);
    sessionStorage.setItem(UTM_KEY, JSON.stringify(base));
  }
};

export const getUtm = () => {
  try { return JSON.parse(sessionStorage.getItem(UTM_KEY) || '{}'); } catch { return {}; }
};

/** camelCase attribution fields to spread into any form submission. */
export const utmPayload = (site = 'main') => {
  const u = getUtm();
  return {
    utmSource: u.utm_source || null,
    utmMedium: u.utm_medium || null,
    utmCampaign: u.utm_campaign || null,
    utmContent: u.utm_content || null,
    utmTerm: u.utm_term || null,
    referralSource: u.ref || u.referrer || null,
    landingPath: u.landing || null,
    site,
  };
};

const PROMO_VARIANT_KEY = 'lokal_promo_variant';

/** Sticky A/B variant for the promo popup (50/50, persisted per visitor). */
export const getPromoVariant = () => {
  let v = localStorage.getItem(PROMO_VARIANT_KEY);
  if (v !== 'A' && v !== 'B') {
    v = Math.random() < 0.5 ? 'A' : 'B';
    try { localStorage.setItem(PROMO_VARIANT_KEY, v); } catch { /* ignore */ }
  }
  return v;
};

/** Fire-and-forget promo A/B event. event: 'view' | 'submit'. */
export const trackPromo = (variant, event, trigger) => {
  axios.post(`${API}/track/promo`, { variant, event, trigger }).catch(() => {});
};

/** Fire-and-forget CTA click event. site: 'main' | 'corp'. */
export const trackCta = (site, path, ctaId) => {
  const u = getUtm();
  axios.post(`${API}/track/cta`, {
    site,
    path,
    ctaId,
    pagePath: window.location.pathname,
    host: window.location.hostname,
    utmSource: u.utm_source || null,
    utmMedium: u.utm_medium || null,
    utmCampaign: u.utm_campaign || null,
    utmContent: u.utm_content || null,
    referrer: u.ref || u.referrer || null,
  }).catch(() => {});
  if (window.fbq) window.fbq('trackCustom', 'CTAClick', { site, path, ctaId });
};

const inferPath = (hint) => {
  const h = hint.toLowerCase();
  if (/book|consult|schedule|call/.test(h)) return 'book_call';
  if (/order/.test(h)) return 'order';
  if (/wedding/.test(h)) return 'weddings';
  if (/klone|discover/.test(h)) return 'klone';
  if (/woty|contest|wine-of-the-year|artist/.test(h)) return 'contest';
  if (/newsletter|subscribe|vip|loyalty/.test(h)) return 'newsletter';
  if (/wines|browse/.test(h)) return 'wines';
  return 'other';
};

/**
 * Delegated tracker for the main site: any <button>/<a> with data-track="path:ctaId"
 * or a data-testid gets logged automatically.
 */
export const attachMainSiteTracker = () => {
  const handler = (e) => {
    if (window.location.pathname.startsWith('/admin')) return;
    const el = e.target.closest('[data-track], button[data-testid], a[data-testid]');
    if (!el) return;
    let path; let ctaId;
    if (el.dataset.track) {
      [path, ctaId] = el.dataset.track.includes(':') ? el.dataset.track.split(':') : [null, el.dataset.track];
    }
    ctaId = ctaId || el.dataset.testid;
    if (!ctaId) return;
    path = path || inferPath(`${ctaId} ${el.getAttribute('href') || ''} ${el.textContent || ''}`);
    trackCta('main', path, ctaId);
  };
  document.addEventListener('click', handler, true);
  return () => document.removeEventListener('click', handler, true);
};
